import * as React from 'react';
import { Helmet } from './meta';

type Props = {
  title: string;
  children: React.ReactChild;
};

const WithTitle: React.FC<Props> = ({ title, children }) => (
  <>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {children}
  </>
);

export default WithTitle;
